import { Box, Tabs, Tab } from '@mui/material';
import { Add } from '@mui/icons-material';
import { TemplateTabsProps } from './types';
import { BaseThreeDotMenu } from '../../../../BaseThreeDotMenu/BaseThreeDotMenu';
import { EditTemplateModal } from '../EditTemplateModal/EditTemplateModal';
import ConfirmationModal from '../../../../Modal/ConfirmationModal';
import { useTemplateTabsActions } from './useTemplateTabsActions';
import './TemplateTabs.scss';

export const TemplateTabs = ({
  templates,
  activeTemplateId,
  onTemplateSelect,
  onAddTemplate,
}: TemplateTabsProps) => {
  // Find the index of the active template
  const activeIndex = templates.findIndex(t => t.id === activeTemplateId);

  // Get the active template name
  const activeTemplate = templates.find(t => t.id === activeTemplateId);
  const activeTemplateName = activeTemplate?.name || null;

  // Handle tab change
  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: number
  ): void => {
    // Check if the clicked tab is the "+" button (last tab)
    if (newValue === templates.length) {
      onAddTemplate();
      return;
    }

    // Otherwise, select the template
    const selectedTemplate = templates[newValue];
    if (selectedTemplate) {
      onTemplateSelect(selectedTemplate.id);
    }
  };

  // Template actions hook
  const {
    menuItems,
    editModalOpen,
    handleCloseEditModal,
    handleEditSubmit,
    selectedTemplateName,
    existingTemplateNames,
    deleteModalOpen,
    handleCloseDeleteModal,
    handleDeleteConfirm,
    isDeleting,
  } = useTemplateTabsActions({
    activeTemplateId,
    activeTemplateName,
  });

  return (
    <>
      <Box className="templateTabsContainer">
        <Box className="tabsWrapper">
          <Tabs
            value={activeIndex !== -1 ? activeIndex : false}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {templates.map(template => (
              <Tab key={template.id} label={template.name} />
            ))}
            <Tab icon={<Add />} label="New Template" />
          </Tabs>
        </Box>

        <Box className="menuWrapper">
          <BaseThreeDotMenu
            menuItems={menuItems}
            disabled={activeTemplateId === null}
            tooltip="Template actions"
          />
        </Box>
      </Box>

      {/* Edit Template Modal */}
      <EditTemplateModal
        open={editModalOpen}
        templateId={activeTemplateId}
        currentName={selectedTemplateName}
        existingTemplateNames={existingTemplateNames}
        onClose={handleCloseEditModal}
        onSubmit={handleEditSubmit}
      />

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        open={deleteModalOpen}
        title="Delete Template"
        message={`Are you sure you want to delete the template "${activeTemplateName}"? This action cannot be undone.`}
        confirmText={isDeleting ? 'Deleting...' : 'Delete'}
        cancelText="Cancel"
        onConfirm={handleDeleteConfirm}
        onCancel={handleCloseDeleteModal}
        severity="error"
      />
    </>
  );
};
